import { axiosClient } from '@/plugins/axios'
import { AxiosResponse } from 'axios'
import { GeoStreetsResponse, StreetResponse } from '../interfaces'

/**
 * 町丁目マスタ取得 API
 *
 * @param townIds 町域IDs
 * @returns 町丁目マスタ取得 Promise
 */
export function getStreets(townIds: string[]): Promise<AxiosResponse<StreetResponse>> {
  if (townIds.length === 0) return Promise.reject()
  return axiosClient.get<StreetResponse>('/streets/', {
    params: {
      townIds
    }
  })
}

/**
 * 町丁目ポリゴンデータの署名付きURL取得
 *
 * @param prefectureId - 都道府県ID
 * @returns Response Promise
 */
export function getStreetsGeo(prefectureId: string): Promise<AxiosResponse<GeoStreetsResponse>> {
  return axiosClient.get<GeoStreetsResponse>('/streets/geo/', { params: { prefectureId:prefectureId } })
}
